import { StaticPropsComponentExtensions } from '@shared/feature/component-static-extensions';
import { BaseNavigationService } from '@shared/utils/navigation';
import { take } from 'rxjs';

export abstract class BaseHelperComponent extends StaticPropsComponentExtensions {
  constructor(private navigationService: BaseNavigationService) {
    super();
  }

  navigateBack(): void {
    this.navigationService
      .navigate(false)
      .pipe(take(1))
      .subscribe(() => {});
  }
}
